import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AntPopconfirm from 'antd/lib/popconfirm';
import './style';

const propTypes = {
  className: PropTypes.string,
  ...AntPopconfirm.propTypes,
};

function Popconfirm({ className, ...rest }) {
  const computedClassName = classNames('bsa-popconfirm', className);
  return (
    <AntPopconfirm
      className={computedClassName}
      {...rest}
    />
  );
}

Popconfirm.defaultProps = AntPopconfirm.defaultProps;
Popconfirm.propTypes = propTypes;
export default Popconfirm;
